function transformItem2Dto(item) {
  const dto = {
    ...item,
    glAccountID: item.id
  };
  delete dto.id;
  delete dto.descriptionEx;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.glAccountID,
    descriptionEx: dto.glAccountNumber + ' ' + dto.description
  };
  delete item.glAccountID;
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };
